'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';
import { CircleCheckBig, LoaderCircle } from 'lucide-react';
import InfoIcon from '/public/info.svg';
import CloseCircle from '/public/close-circle.svg';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  console.log('Toaster props:', props);

  return (
    <Sonner
      duration={props.duration || 2000}
      theme={theme as ToasterProps['theme']}
      className="toaster group w-auto"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--width': '232px',
        } as React.CSSProperties
      }
      position="top-right"
      mobileOffset={{
        left: '50%',
      }}
      toastOptions={{
        className:
          'justify-center w-[232px]! max-w-[232px] whitespace-wrap left-1/2 -translate-x-1/2',
      }}
      icons={{
        success: <CircleCheckBig className="w-4 h-4 text-[var(--primary)]" />,
        error: <CloseCircle className="w-4 h-4 text-[var(--destructive)]" />,
        loading: (
          <LoaderCircle className="w-4 h-4 text-[var(--primary)] animate-spin" />
        ),
        info: <InfoIcon className="w-4 h-4 text-[var(--primary)]" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
